import {
	CREATE,
	GET_ONE,
	UPDATE,
} from 'react-admin';
import { createTradeUnion } from '../model/cloud';

export const addTradeUnion = (requestHandler) => (type, resource, params) => {
	if (resource === 'TradeUnion') {
		switch (type) {
			case CREATE:
				return createTradeUnion({
					shortTitle: params.data.shortTitle,
					fullTitle: params.data.fullTitle,
				})
					.then((id) => requestHandler(GET_ONE, resource, { id }));
			case UPDATE:
				delete params.data.adminRole; // eslint-disable-line no-param-reassign
				return requestHandler(type, resource, params);
			default:
				break;
		}
	}

	return false;
};
